import React from 'react';
import { toast } from 'react-toastify';
import { Notification, NotificationType } from 'components/Base';

const NOTIFICATION_CLOSE_DELAY = 2500;

export const notifyAlert = (error: string) => {
  toast(<Notification message={error} type={NotificationType.Alert} />, {
    position: 'bottom-right',
    autoClose: NOTIFICATION_CLOSE_DELAY,
    hideProgressBar: true,
    pauseOnHover: true,
    className: 'notification_container',
    bodyClassName: 'text_small notification_body',
  });
};

export const notifyInfo = (info: string) => {
  toast(<Notification message={info} type={NotificationType.Info} />, {
    position: 'bottom-right',
    autoClose: NOTIFICATION_CLOSE_DELAY,
    hideProgressBar: true,
    pauseOnHover: true,
    className: 'notification_container',
    bodyClassName: 'text_small notification_body',
  });
};
